import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { Storage } from "@faire/web--source/common/Storage";
import omit from "lodash/omit";
import { SelfServeNodeLevels } from "../types";
var SELECTED_ISSUES_KEY = "SELECTED_ISSUES_KEY";
var SELECTED_BRAND_ORDER = "SELECTED_BRAND_ORDER";
var STEP_KEY = "STEP_KEY";
var StorageService = Storage.local;
var SELECTED_NODE_KEY = "SELECTED_NODE_KEY";
export var clearLocalStorage = function clearLocalStorage() {
  StorageService.removeItem(SELECTED_ISSUES_KEY);
  StorageService.removeItem(SELECTED_BRAND_ORDER);
  StorageService.removeItem(STEP_KEY);
  StorageService.removeItem(SELECTED_NODE_KEY);
};
export var clearSelectedBrandOrderLocalStorage = function clearSelectedBrandOrderLocalStorage() {
  StorageService.removeItem(SELECTED_BRAND_ORDER);
};
export var clearNodesFromLocalStorage = function clearNodesFromLocalStorage() {
  clearCurrentNodeLevelAndAboveFromLocalStorage(0);
};
export var clearCurrentNodeLevelAndAboveFromLocalStorage = function clearCurrentNodeLevelAndAboveFromLocalStorage(currentNodeLevel) {
  var storageValue = StorageService.getItem(SELECTED_NODE_KEY);
  var currentNodeValue = {};
  if (storageValue) {
    currentNodeValue = JSON.parse(storageValue);
    for (var i = currentNodeLevel; i <= SelfServeNodeLevels.length; i++) {
      currentNodeValue = omit(currentNodeValue, i);
    }
  }
  StorageService.setItem(SELECTED_NODE_KEY, JSON.stringify(currentNodeValue));
};
export var setSelectedBrandOrderToLocalStorage = function setSelectedBrandOrderToLocalStorage(brandOrder) {
  StorageService.setItem(SELECTED_BRAND_ORDER, JSON.stringify(brandOrder));
};
export var getSelectedBrandOrderFromLocalStorage = function getSelectedBrandOrderFromLocalStorage() {
  var selectedBrandOrder = StorageService.getItem(SELECTED_BRAND_ORDER);
  return selectedBrandOrder ? JSON.parse(selectedBrandOrder) : undefined;
};
/**
 * Set selected node to local storage
 * The reason we set nodeId instead of the entire SelfServeNode is that HTML element can't be stringified
 * @param selfServeNodeLevel
 * @param selfServeNodeId
 */
export var setSelectedNodeToLocalStorage = function setSelectedNodeToLocalStorage(selfServeNodeLevel, selfServeNodeId) {
  var _StorageService$getIt;
  clearCurrentNodeLevelAndAboveFromLocalStorage(selfServeNodeLevel);
  var nodesInLocalStorage = (_StorageService$getIt = StorageService.getItem(SELECTED_NODE_KEY)) !== null && _StorageService$getIt !== void 0 ? _StorageService$getIt : "{}";
  var parsedNodesInLocalStorage = JSON.parse(nodesInLocalStorage);
  var updatedNodes = JSON.stringify(_objectSpread(_objectSpread({}, parsedNodesInLocalStorage), {}, _defineProperty({}, selfServeNodeLevel, selfServeNodeId)));
  StorageService.setItem(SELECTED_NODE_KEY, updatedNodes);
};
export var getSelectedNodesFromLocalStorage = function getSelectedNodesFromLocalStorage() {
  var nodes = StorageService.getItem(SELECTED_NODE_KEY);
  return nodes ? JSON.parse(nodes) : undefined;
};